import { Button } from "@/atoms-react/button/Button.react";
import { Modal, ModalContent } from "@/atoms-react/modal/index.react";
import { Base } from "@/atoms-react/text/Text.react";
import { AgentNatureMandate } from "@/features/company/types";
import { LinkSchemas } from "@/types/legal-entity/links.type";
import { Themes } from "@/types/theme";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

type ModalValidateCompanyProps = {
  open: boolean;
  onClose: (success: boolean) => void;
  links: LinkSchemas[] | undefined;
};
export const ModalValidateCompany = ({ open, onClose, links }: ModalValidateCompanyProps) => {
  const { t } = useTranslation(["pass"]);

  const handleCompanyAddComplete = async () => {
    const legalMandate = links?.find(
      (link) =>
        link.agentNature?.defaultName === AgentNatureMandate.LEGAL_REPRESENTATIVE ||
        link.agentNature?.defaultName === AgentNatureMandate.JUDICIAL_AGENT
    );
    if (!legalMandate) {
      toast.error(t("business_links.validation.error"));
      onClose(false);
      return;
    }

    try {
      toast.success(t("business_links.validation.success_complete"));
      onClose(true);
    } catch (_) {
      toast.error(t("business_links.validation.error_completed"));
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose(false);
      }}
      className="w-full max-w-2xl sm:w-full md:px-20 md:py-12"
    >
      <ModalContent title={t("business_links.confirm_creation_modal.title")}>
        <div className="mt-4 flex flex-col gap-4 text-center">
          <Base>{t("business_links.confirm_creation_modal.description")}</Base>
          <div className="mt-6 flex justify-center gap-4">
            <Button onClick={() => onClose(false)} theme={Themes.white} className="w-max">
              {t("olkypass.general.cancel")}
            </Button>
            <Button onClick={handleCompanyAddComplete} className="w-max" theme={Themes.success}>
              {t("olkypass.general.confirm")}
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};
